/**
 * AppErrorFallback
 * Fallback UI for the top-level Sentry.ErrorBoundary (audit J1). A render crash used to
 * blank the whole app to a white screen; this gives the user a readable message and a way
 * to recover (reload) instead.
 */

type AppErrorFallbackProps = {
  onReset: () => void;
};

export function AppErrorFallback({ onReset }: AppErrorFallbackProps) {
  return (
    <main className="w-full h-screen flex items-center justify-center bg-[#262624] px-6">
      <div className="flex flex-col items-center gap-4 max-w-md text-center" role="alert">
        <div className="w-16 h-16 bg-red-500/15 rounded-full flex items-center justify-center">
          <svg
            className="w-8 h-8 text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div>
          <h1 className="text-xl font-semibold text-white mb-2">Что-то пошло не так</h1>
          <p className="text-gray-400 text-sm">
            Произошла непредвиденная ошибка. Ваши данные сохранены — попробуйте перезагрузить страницу.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => {
              onReset();
              window.location.reload();
            }}
            className="px-5 py-2 rounded-lg bg-white text-[#262624] text-sm font-medium transition-colors hover:bg-gray-200"
          >
            Перезагрузить
          </button>
        </div>
      </div>
    </main>
  );
}
